import React from 'react';
import styled from 'styled-components';
import campaignService from '~/api/services/campaignService';
import { CtaButton, CtaColorScheme } from '~/components/cta/regular';
import { Input } from '~/components/forms/StyledForm';
import { CustomHead } from '~/components/Head';
import { minWidth } from '~/styles/media';
import theme from '~/styles/styledComponentsTheme';

const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  @media ${minWidth('md')} {
    flex-direction: row;
  }

  margin: 16px;
  @media ${minWidth('sm')} {
    margin: 48px;
  }

  img {
    width: 100%;
  }
`;

const LeftSide = styled.div`
  width: 100%;
  @media ${minWidth('md')} {
    width: 50%;
  }
`;

const RightSide = styled.div`
  width: auto;
  margin-bottom: 10px;
  margin-left: 0;
  @media ${minWidth('md')} {
    width: 50%;
    margin-bottom: 0;
    margin-left: 50px;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${theme.grey_1_0};

  > h2 {
    max-width: 500px;
    color: ${theme.darkNightBlack};
  }
  > p {
    margin: 20px 0;
  }
  > form {
    display: flex;
    max-width: 550px;
  }
`;

const Subscribe: React.FC = () => {
  const [email, setEmail] = React.useState('');

  const subscribe = async (e: React.MouseEvent) => {
    e.preventDefault();
    await campaignService.subscribeWithPop(email, 'TyP6hy');
  };

  return (
    <Container>
      <CustomHead title="Press Releases - Love Stories TV" />
      <LeftSide>
        <img src="/images/footer-subscribe.jpg" alt="subscribe" />
      </LeftSide>
      <RightSide>
        <h2>Want to See More of the Most Inspiring Wedding Videos?</h2>
        <p>Get your regular dose of emotional and gorgeous wedding videos in your inbox.</p>
        <form>
          <div style={{ flexGrow: 1 }}>
            <Input
              placeholder="Your Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              $placeholderColor={theme.grey_1_0}
            />
          </div>
          <div style={{ marginLeft: 10 }}>
            <CtaButton caption="Subscribe" $colorScheme={CtaColorScheme.Highlight} onClick={(e) => subscribe(e)} />
          </div>
        </form>
        <div>
          By signing up, I agree to the <a href="/terms-of-use">Terms</a> and{' '}
          <a href="/privacy-policy">Privacy Policy</a>.
        </div>
      </RightSide>
    </Container>
  );
};

export default Subscribe;
